import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import AppVFRSettings from './app-vfr-settings.component';
import AppBRDSettings from './app-brd-settings.component';
import AppGUMGUMSettings from './app-gumgum-settings.component';
import ConfirmPopup from '../common/confirm-popup.component';
import OzyPlaySettings from './app-ozyplay-settings.component';

const TABS_CONFIG = [
  { value: 'BRD', label: 'Bright-SDK', component: AppBRDSettings },
  { value: 'VFR', label: 'VFR', component: AppVFRSettings },
  { value: 'GumGum', label: 'GumGum', component: AppGUMGUMSettings },
  { value: 'WHALETV', label: 'WhaleTV', component: OzyPlaySettings },
];

const AppThirdPartyIntegrations = ({ channelDetail, handleRefreshData }) => {
  const [tabValue, setTabValue] = useState(TABS_CONFIG[0].value);
  const [hasFormValueChanged, setHasFormValueChanged] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const tabValueRef = useRef('');

  const formValueChangedCallback = (val) => {
    setHasFormValueChanged(val);
  };

  const handleTabSwitchSuccess = () => {
    setTabValue(tabValueRef.current);
    setHasFormValueChanged(false);
    setShowWarning(false);
  };

  return (
    <Box component={Paper} p={1}>
      <Box height="100%" display="flex">
        <Tabs
          value={tabValue}
          aria-label="tabs"
          orientation="vertical"
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="transparent"
          sx={{ minWidth: 150, maxWidth: 150 }}
          onChange={(_, v) => {
            if (hasFormValueChanged) {
              tabValueRef.current = v;
              setShowWarning(true);
            } else {
              setTabValue(v);
            }
          }}
        >
          {TABS_CONFIG.map((tab, index) => (
            <Tab
              key={index + 1}
              value={tab.value}
              label={tab.label}
              sx={{
                background: tabValue === tab.value && '#f2f2f2',
                borderLeft: tabValue === tab.value && '2px solid #FD0100',
                alignItems: 'flex-start',
                textAlign: 'left',
              }}
            />
          ))}
        </Tabs>

        {TABS_CONFIG.map(
          ({ value, component: Component }) =>
            tabValue === value && (
              <Component
                key={value}
                channelDetail={channelDetail}
                type={tabValue}
                handleRefreshData={handleRefreshData}
                formValueChangedCallback={formValueChangedCallback}
              />
            )
        )}
      </Box>

      {showWarning && (
        <ConfirmPopup
          title="Tab Switch Warning"
          message="Do you want to switch tab without saving data? Before switching tab, save your changes otherwise you lost all your changes and can not undo this action!"
          onCancel={() => setShowWarning(false)}
          onSuccess={() => handleTabSwitchSuccess()}
        />
      )}
    </Box>
  );
};

AppThirdPartyIntegrations.propTypes = {
  channelDetail: PropTypes.object.isRequired,
  handleRefreshData: PropTypes.func.isRequired,
};

export default AppThirdPartyIntegrations;
